<template>
    <div class="cart__table cart-table cart__kit-table">
        <div class="card-kit-subheader"><h5>Optional Components</h5></div>
        <table class="cart-table__table">

            <thead class="cart-table__head">
                <tr class="cart-table__row">
                    <th class="cart-table__column cart-table__column--image">Image</th>
                    <th class="cart-table__column cart-table__column--quantity">Quantity</th>										
                    <th class="cart-table__column cart-table__column--product">Product</th>	
                    <th class="cart-table__column cart-table__column--kit-size">Size</th>
                    <th class="cart-table__column cart-table__column--numeral">Availability</th>
                    <th class="cart-table__column cart-table__column--price">Price</th>
                    <th class="cart-table__column cart-table__column--total">Total</th>
                    <th class="cart-table__column cart-table__column--remove" width="20px"></th>
                </tr>
            </thead>
            <tbody class="cart-table__body" v-if="opt_cart.length > 0">
                <optional-item v-for="(optional, index) in opt_cart"
                :key="index"
                :optional_item="optional"
                :sizes="sizes(optional.sku)"
                @changed_qty="changed_qty"
                @viewAlternative="productAlternatives"
                @remove-alternatives="removeAlternatives"
                ></optional-item>
            </tbody>
        </table>
    </div>

    <product-alternative
        :show="showAlternative"
        :alternatives="alternatives"
        :sequence="sequence"
        :size_sel='size_sel'
        @close="showAlternative = false"
        @select-alternative="alternative_item"
    >
    </product-alternative>
</template>

<script>
import OptionalItem from './OptionalItem.vue';
import ProductAlternative from './ProductAlternative.vue';

export default {

    components: {OptionalItem, ProductAlternative},

    data() {
        return {
            opt_cart : this.optionals,
            opt_total: 0,
            prod_alternatives: [],
            alternatives: [],
            size_sel: '',
            showAlternative: false,
        }
    },

    emits: ['opt_ltotal'],

    props: {
        isAddToCart : {
            type: Boolean
        },
        optionals: {
            type: Array
        },
        substitutes: {
            type: Array
        },
        kit_sizes: {
            type: Array
        }
    },

    methods: {
        sizes(sku) {
            const sizes = this.optionals.filter(s => s.QITEMNUM == sku && s.QSIZEITM != '');
            // console.log(sizes);
            return sizes;   
        },
        changed_qty(opt, qty) {
            // console.log(opt);
            // console.log(qty);
            this.opt_total = 0;
            this.opt_cart.forEach(k => {
                if(k.sku == opt.sku){
                    k.quantity = qty;
                }
                const linetotal = k.quantity * k.yourprice;
                // console.log('linetotal = ' + linetotal);
                this.opt_total += linetotal;
            });

            // console.log('OPT TOTAL = ' + this.opt_total);
            // console.log(this.cart_items);
            
            this.$emit('opt_ltotal', opt, this.opt_total);
        },

        hasAlternative() {
            // this.prod_alternatives = this.optionals.filter(k => k.info == 'SUBSTITUTE');
            // return this.substitutes.length;
        },

        productAlternatives(kit, size_sel) {
            // console.log(kit);
            this.size_sel = size_sel;
            this.alternatives = kit.alternatives;
            this.showAlternative = true;
            // this.sequence = KCSEQN;
        },

        /**
         *  optional item selected alternative
         */
        alternative_item(alt_item, alternative) {
            // console.log(alt_item);
            // console.log(alternative);
            let ciIndx;
            let alternatives = [];
            const selected_alt = alternative.find(a => a.item == alt_item);
            const oitems = this.opt_cart;
            let p = null;
            // console.table(selected_alt);
            oitems.forEach((ci, ci_index) => {
                if(ci.KCSEQN == selected_alt.KCSEQN){
                    ciIndx = ci_index;
                    alternatives = ci.alternatives.filter(a => a.item != alt_item);
                    ci.alternatives = [];
                    alternatives.push(ci);
                    p = ci;
                    return;
                }
            });
            selected_alt.quantity = p.quantity
            this.opt_cart[ciIndx] = selected_alt;
            this.opt_cart[ciIndx].alternatives = alternatives;
            // console.log(this.opt_cart[ciIndx]);
            setTimeout(() => {
                this.countTotal();    
            }, 200);
            
        },

        countTotal() {
            this.opt_total = 0;
            this.opt_cart.forEach(k => {
                // console.log(k);
                const linetotal = k.quantity * k.yourprice;
                this.opt_total += linetotal;
                // console.log('linetotal = ' + linetotal)
                this.$emit('opt_ltotal', k, linetotal);
            });
        },

        removeAlternatives(alt_item) {
            this.alternative_item(alt_item.origItem, alt_item.alternatives);
        }

    },

    watch: {
        optionals() {
            // console.log(newVals);
        },
    },
    updated() {
        // this.opt_cart = this.optionals;
        // this.opt_cart.forEach(o => {
        //     o.quantity = 0;
        // });
        // console.log(this.optionals);
    },
    mounted() {
        // console.log(this.optionals);
    },
    created() {
        // console.log(this.optionals);
    }
}
</script>